import ListData from "./ListData";

export default ListData;
